import { isTDraft, TResolvedItemNames } from '@modules/items';
import { TBlockData, TBlockDataVersion, TBlockVersionMode } from '../types/blocks.types';
import { TDocument, TDraft, TVersion } from '../types';

export const getBlockDisplayName = (
  doc: TDocument,
  version: TDraft | TVersion | undefined,
  resolvedItemNames: TResolvedItemNames,
  blockData: TBlockData | undefined,
  blockVersionMode: TBlockVersionMode,
  blockVersionEntry?: TBlockDataVersion
): string => {
  let blockName = blockData?.itemName || 'Unknown';
  if (blockVersionEntry?.variantFolderId !== 'default')
    if (blockVersionEntry?.variantFolderId)
      blockName += ` › ${resolvedItemNames[blockVersionEntry.variantFolderId] || 'Unknown'}`;
    else blockName += ` › No matching variant`;
  if (blockVersionEntry && (blockVersionMode === 'SPECIFIC' || (version && !isTDraft(version))))
    blockName += ` (v${blockVersionEntry.blockVersion})`;
  return blockName;
};
